import { Handshake } from "lucide-react";

// Dealer-only variant of the Wellside Canopies page's "Become A Dealer"
// utility bar (no fleet/trade wording — fleet buyers don't apply to
// individually-sold accessories like roof tents/awnings, unlike Wellside's
// multi-canopy fleet buyers). Fixed directly below the site's main header
// (h-20/80px, hence top-20), only on the page it's used on.
export const DealerStickyBar = ({ onOpenModal, testIdPrefix }) => (
  <div
    data-testid={`${testIdPrefix}-dealer-sticky-bar`}
    className="fixed top-20 inset-x-0 z-40 flex items-center justify-center gap-2 md:gap-3 bg-[var(--brand-primary)] text-black py-2 md:py-2.5 px-4 text-center flex-wrap"
  >
    <Handshake size={14} strokeWidth={2} className="flex-shrink-0" />
    <span className="hidden sm:inline font-mono text-[11px] md:text-xs uppercase tracking-[0.15em] font-medium">
      Want to become a dealer?
    </span>
    <button
      type="button"
      onClick={onOpenModal}
      data-testid={`${testIdPrefix}-become-dealer-badge`}
      className="font-mono text-[11px] md:text-xs uppercase tracking-[0.15em] font-semibold underline hover:no-underline"
    >
      Become A Dealer →
    </button>
  </div>
);
